/* @generated from adl module ferovinum.sourcecontracts.physicaladdress */

import * as ADL from './../../runtime/adl';
import * as common_strings from './../../common/strings';
import * as ferovinum_app_db from './../app/db';

/**
 * The published `source__app_db.physical_address` contract.
 */
export interface PhysicalAddressSource {
  id: ferovinum_app_db.PhysicalAddressId;
  entityId: common_strings.StringNE;
  addressType: common_strings.StringNE;
  line1: common_strings.StringNE;
  line2: (common_strings.StringNE|null);
  line3: (common_strings.StringNE|null);
  town: common_strings.StringNE;
  state: (common_strings.StringNE|null);
  postCode: common_strings.StringNE;
  country: common_strings.StringNE;
}

export function makePhysicalAddressSource(
  input: {
    id: ferovinum_app_db.PhysicalAddressId,
    entityId: common_strings.StringNE,
    addressType: common_strings.StringNE,
    line1: common_strings.StringNE,
    line2: (common_strings.StringNE|null),
    line3: (common_strings.StringNE|null),
    town: common_strings.StringNE,
    state: (common_strings.StringNE|null),
    postCode: common_strings.StringNE,
    country: common_strings.StringNE,
  }
): PhysicalAddressSource {
  return {
    id: input.id,
    entityId: input.entityId,
    addressType: input.addressType,
    line1: input.line1,
    line2: input.line2,
    line3: input.line3,
    town: input.town,
    state: input.state,
    postCode: input.postCode,
    country: input.country,
  };
}

const PhysicalAddressSource_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.sourcecontracts.physicaladdress","decl":{"annotations":[{"value":{"modelName":"source__app_db.physical_address","grain":["id"],"tags":["revenue","source"]},"key":{"moduleName":"ferovinum.sourcecontracts.common","name":"SourceContract"}},{"value":"The published `source__app_db.physical_address` contract.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"PhysicalAddressId"}},"parameters":[]}},{"annotations":[],"serializedName":"entityId","default":{"kind":"nothing"},"name":"entityId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"addressType","default":{"kind":"nothing"},"name":"addressType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"line1","default":{"kind":"nothing"},"name":"line1","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"line2","default":{"kind":"nothing"},"name":"line2","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"line3","default":{"kind":"nothing"},"name":"line3","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"town","default":{"kind":"nothing"},"name":"town","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"state","default":{"kind":"nothing"},"name":"state","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"postCode","default":{"kind":"nothing"},"name":"postCode","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"country","default":{"kind":"nothing"},"name":"country","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"PhysicalAddressSource","version":{"kind":"nothing"}}};

export const snPhysicalAddressSource: ADL.ScopedName = {moduleName:"ferovinum.sourcecontracts.physicaladdress", name:"PhysicalAddressSource"};

export function texprPhysicalAddressSource(): ADL.ATypeExpr<PhysicalAddressSource> {
  return {value : {typeRef : {kind: "reference", value : snPhysicalAddressSource}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.sourcecontracts.physicaladdress.PhysicalAddressSource" : PhysicalAddressSource_AST
};
